define([
	"dojo/_base/declare",
	"csi/xml"
], function(declare,xml) {

	return declare(null, {
		_updateFieldsFromSpecification: function(/*Node*/spec) {
			this._updateCreateQuoteFieldFromSpecification(spec);
			this._updateNameFieldFromInputNode(spec);
		},

		_updateCreateQuoteFieldFromSpecification: function(/*Node*/spec) {
			var createQuoteField = this.defView.getField("CreateQuote");
			if (createQuoteField) {
				this.setFieldValue(createQuoteField, spec && spec.SupplierQuoteExpected, true);
			}
		},

		_updateNameFieldFromInputNode: function(/*Node*/fromNode) {
			var nameField = this.defView.getField(xml.ATTR_NAME);
			if (nameField.isDefaultValue())
				this.setFieldValue(nameField, fromNode ? fromNode.$Name : "", true);
		}
	});
});